import { useContext, useMemo } from 'react';
import { ProjectProgressionFiltersContext } from '../../../state/filters/contexts';
import { size } from 'lodash';

export const PP_EMPTY_STATES_TYPES = {
  MISSING_FILTERS: 'MISSING_FILTERS'
};

const useEmptyStateType = () => {
  const {
    state: { filtersPayload, isInitialized }
  } = useContext(ProjectProgressionFiltersContext);

  const emptyStateType = useMemo(() => {
    if (!isInitialized) return null;

    if (size(filtersPayload) === 0)
      return PP_EMPTY_STATES_TYPES.MISSING_FILTERS;

    return null;
  }, [filtersPayload, isInitialized]);

  return emptyStateType;
};

export default useEmptyStateType;
